
import { WorldCountry } from '../types';
import { brazilAdditionalCities } from './brazilExpansion';

export const brazilData: WorldCountry = {
  code: 'BR',
  name: 'Brazil',
  slug: 'brazil',
  population: 215313498,
  topCities: [
    { name: 'São Paulo', slug: 'sao-paulo', population: 12396372 },
    { name: 'Rio de Janeiro', slug: 'rio-de-janeiro', population: 6748000 },
    { name: 'Brasília', slug: 'brasilia', population: 3055149 },
    { name: 'Salvador', slug: 'salvador', population: 2886698 },
    { name: 'Fortaleza', slug: 'fortaleza', population: 2686612 },
    { name: 'Belo Horizonte', slug: 'belo-horizonte', population: 2521564 },
    { name: 'Manaus', slug: 'manaus', population: 2219580 },
    { name: 'Curitiba', slug: 'curitiba', population: 1963726 },
    { name: 'Recife', slug: 'recife', population: 1653461 },
    { name: 'Goiânia', slug: 'goiania', population: 1536097 },
    { name: 'Belém', slug: 'belem', population: 1499641 },
    { name: 'Porto Alegre', slug: 'porto-alegre', population: 1488252 },
    { name: 'Guarulhos', slug: 'guarulhos-original', population: 1392121 },
    { name: 'Campinas', slug: 'campinas-original', population: 1213792 },
    { name: 'São Luís', slug: 'sao-luis-original', population: 1108975 },
    { name: 'São Gonçalo', slug: 'sao-goncalo-original', population: 1084839 },
    { name: 'Maceió', slug: 'maceio-original', population: 1025360 },
    { name: 'Duque de Caxias', slug: 'duque-de-caxias-original', population: 924624 },
    { name: 'Campo Grande', slug: 'campo-grande-original', population: 906092 },
    { name: 'Natal', slug: 'natal-original', population: 890480 },
    { name: 'Teresina', slug: 'teresina-original', population: 868075 },
    { name: 'São Bernardo do Campo', slug: 'sao-bernardo-do-campo-original', population: 844483 },
    { name: 'Nova Iguaçu', slug: 'nova-iguacu-original', population: 821128 },
    { name: 'João Pessoa', slug: 'joao-pessoa-original', population: 817511 },
    { name: 'Santo André', slug: 'santo-andre-original', population: 721368 },
    { name: 'São José dos Campos', slug: 'sao-jose-dos-campos-original', population: 729737 },
    { name: 'Jaboatão dos Guararapes', slug: 'jaboatao-dos-guararapes-original', population: 706867 },
    { name: 'Ribeirão Preto', slug: 'ribeirao-preto-original', population: 703293 },
    { name: 'Osasco', slug: 'osasco-original', population: 699944 },
    { name: 'Uberlândia', slug: 'uberlandia-original', population: 699097 },
    { name: 'Sorocaba', slug: 'sorocaba-original', population: 695328 },
    { name: 'Contagem', slug: 'contagem-original', population: 668949 },
    { name: 'Aracaju', slug: 'aracaju-original', population: 664908 },
    { name: 'Feira de Santana', slug: 'feira-de-santana-original', population: 619609 },
    { name: 'Cuiabá', slug: 'cuiaba-original', population: 650912 },
    { name: 'Joinville', slug: 'joinville-original', population: 597658 },
    { name: 'Juiz de Fora', slug: 'juiz-de-fora-original', population: 573285 },
    { name: 'Londrina', slug: 'londrina-original', population: 575377 },
    { name: 'Ananindeua', slug: 'ananindeua-original', population: 535547 },
    { name: 'Aparecida de Goiânia', slug: 'aparecida-de-goiania-original', population: 521002 },
    { name: 'Caxias do Sul', slug: 'caxias-do-sul-original', population: 517451 },
    { name: 'Niterói', slug: 'niteroi-original', population: 515317 },
    { name: 'Belford Roxo', slug: 'belford-roxo-original', population: 510906 },
    { name: 'Florianópolis', slug: 'florianopolis-original', population: 508826 },
    { name: 'Campos dos Goytacazes', slug: 'campos-dos-goytacazes-original', population: 507548 },
    { name: 'Vila Velha', slug: 'vila-velha-original', population: 501325 },
    { name: 'Mauá', slug: 'maua-original', population: 477552 },
    { name: 'São João de Meriti', slug: 'sao-joao-de-meriti-original', population: 472906 },
    { name: 'Betim', slug: 'betim-original', population: 444784 },
    { name: 'Mogi das Cruzes', slug: 'mogi-das-cruzes-original', population: 440769 },
    { name: 'Santos', slug: 'santos-original', population: 433656 },
    
    // Agregar las 100 ciudades adicionales de la expansión
    ...brazilAdditionalCities
  ]
};
